<template>
  <div class="fasciaBoard-alter">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Fascia (Shell Scheme Only)</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/exinfo/fascia-board');">
          <span>Back</span>
        </div>
      </div>
    </div>
    
    <div class="fasciaBoard-alter-content" v-if="fasciaBoardDownInfo">
      <Form
        ref="formInline"
        :model="formInline"
        label-position="right"
        :label-width="200"
        @submit.native.prevent
      >
        <FormItem label="Submission time：">
          <p class="alter-p">{{fasciaBoardDownInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</p>
        </FormItem>
        <FormItem label="Review status：">
          <p class="alter-p">Pending</p>
        </FormItem>
        <!-- <FormItem label="操作状态：">
          <p class="alter-p">修改</p>
        </FormItem> -->
        <FormItem label="Exhibition Hall：">
          <p class="alter-p" v-if="formInline.exArea">{{formInline.exArea}}</p>
          <p class="alter-p" v-else></p>
        </FormItem>
        <FormItem label="Booth number：">
          <p class="alter-p" v-if="formInline.exHall">{{formInline.exHall}}</p>
          <p class="alter-p" v-else></p>
        </FormItem>
        <FormItem label="Company name：">
          <p class="alter-p" :style="tag || tagCompName? 'color:red':''">{{fasciaBoardDownInfo.compName}}</p>
        </FormItem>
      </Form>
      <Button style="position:absolute;top:30px;right:30px;" @click="$router.push('/exhibitionEn/index/exinfo/fascia-alter-edit')">Edit</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from '@assets/config.json';

export default {
  name: "exhibition-info-fasciaBoardAlter",
  data() {
    return {
      formInline: {
        exArea: "", // 展区
        exHall: "", // 展位号
        comName: "", // 公司中文名
        comNameEn: "", // 公司英文名
      },
      fasciaBoardInfo: null, // 楣板信息内容
      fasciaBoardDownInfo: null, // 楣板信息提交的修改内容
      tag: false,
      tagCompName: false,
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  async created() {
    if (this.joinInfo && this.joinInfo.exArea) {
      this.formInline.exArea = this.joinInfo.exArea;
    }
    // if (this.joinInfo && this.joinInfo.boothInfo) {
    //   let boothInfo = JSON.parse(this.joinInfo.boothInfo);
    //   this.formInline.exArea = this.joinInfo.exArea;
    //   for (let i = 0; i < boothInfo.length; i++) {
    //     if (boothInfo.length > 1) {
    //       this.formInline.exHall += boothInfo[i].Hall + '-' + boothInfo[i].Code + '、';
    //     } else {
    //       this.formInline.exHall += boothInfo[i].Hall + '-' + boothInfo[i].Code;
    //     }
    //   }
    //   // this.formInline.exHall = boothInfo.Hall + boothInfo.Code;
    // }
    if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
        if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
          this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
        }
      }
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
        if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
          this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
        }
        if (this.joinInfo.boothInfo.Hall) {
          this.formInline.exHall = this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
        } else {
          this.formInline.exHall = this.joinInfo.boothInfo.Code;
        }
      }
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
        let boothInfo = this.joinInfo.boothInfo;
        for (let i = 0; i < boothInfo.length; i++) {
          if (boothInfo.length > 1) {
            if (boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
            }
            if (boothInfo[i].Hall && !boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "、";
            }
            if (!boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Code + "、";
            }
            
          } else {
            if (boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "-" + boothInfo[i].Code;
            }
            if (boothInfo[i].Hall && !boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall;
            }
            if (!boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Code;
            }

          }
        }
      }
      // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
    }
    // 获取楣板信息
    let res = await this.getFasciaBoard(this.joinInfo.joinId);
    if (res) {
      this.fasciaBoardInfo = res;
    }

    // 获取楣板修改记录
    let result = await this.getFasciaBoardDown(this.joinInfo.joinId);
    if (result) {
      this.fasciaBoardDownInfo = result;
    }

    // 楣板信息不存在，说明为新增，所有信息红色
    if (!this.fasciaBoardInfo) {
      this.tag = true;
    }
    // 会刊信息存在，修改的信息为红色
    if (this.fasciaBoardInfo) {
      if (this.fasciaBoardInfo.compName !== this.fasciaBoardDownInfo.compName) {
        this.tagCompName = true;
      }
    }
  },
  methods: {
    ...mapActions({
      getFasciaBoard: "exhibitionModule/getFasciaBoard",
      getFasciaBoardDown: "exhibitionModule/getFasciaBoardDown",
    }),
  }
};
</script>

<style lang="scss">
.fasciaBoard-alter {
  .ivu-form-item {
    margin-bottom: 0;
  }
}
</style>
<style scoped lang="scss">
.fasciaBoard-alter {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    position: relative;
  }
  .alter-p {
    line-height: 34px;
  }
}
</style>
